export default {
  arrives: {
    en: 'Arrives in <b>{month} {year}</b>',
  },
}
